module.exports = require("slate");